import { render, staticRenderFns } from "./VehicleDetail.vue?vue&type=template&id=41e44f40&scoped=true"
import script from "./VehicleDetail.vue?vue&type=script&lang=js"
export * from "./VehicleDetail.vue?vue&type=script&lang=js"
import style0 from "./VehicleDetail.vue?vue&type=style&index=0&id=41e44f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e44f40",
  null
  
)

export default component.exports